module.exports = __webpack_public_path__ + "static/media/advenio-logo.4e6a4170.png";